import classNames from 'classnames'; // Import css modules stylesheet as styles
import * as React from 'react';
import { defined } from '../../../utils/variableEvaluation';
import { IInputConfig } from '../index';

interface IProps {
  index: number;
  input: IInputConfig;
  forcedValue?: string;
  checked?: boolean;
  readOnly?: boolean;
  defaultChecked?: boolean;
  onFocus?: () => void;
  onBlur?: () => void;
  disabled?: boolean;
  radioExtraStyles?: string;
}

export function InputRadioOption(props: IProps) {
  const { id, name, label, icon, inputWrapperStyle, value, onChange, disabled } = props.input;

  const handleChange = (e: React.ChangeEvent<any>) => {
    if (!props.readOnly) {
      const name = e.target.name;
      const value = props.input.value;
      onChange(name, value);
    }
  };

  return (
    <li className={'radio'} style={defined(inputWrapperStyle) ? inputWrapperStyle : { width: 'auto' }}>
      <label
        htmlFor={id}
        className={classNames('radioLabel', {
          disabled: disabled,
        })}
      >
        <input
          onChange={handleChange}
          id={id}
          readOnly={props.readOnly}
          className={classNames('radioInput', props.radioExtraStyles)}
          type='radio'
          value={value}
          checked={props.checked}
          name={name}
          defaultChecked={props.defaultChecked}
          onFocus={props.onFocus}
          onBlur={props.onBlur}
          disabled={disabled}
        />
        {icon}
        {label}

        <i
          className={classNames('radioInputMark', {
            checked: props.checked,
          })}
        />
      </label>
    </li>
  );
}
